import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入全局样式
import './styles/variables.css'
import './styles/common.scss'

// 使用 Element UI
Vue.use(ElementUI)

// 关闭生产提示
Vue.config.productionTip = false

// 恢复用户登录状态
store.dispatch('user/restoreLogin')

// 创建 Vue 实例
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
